export const SOURCE_OPTIONS = ["SELF", "WAZE", "SERVICE CALL"];

export const INCIDENT_TYPES = [
  "ACCIDENT",
  "ASSIST MOTORIST",
  "ASSIST OTHER AGENCY",
  "DEBRIS",
  "TEST",
];

export const SERVICE_OPTIONS = [
  "ABANDONED",
  "AIR TIRE",
  "BLOCKED LANE",
  "BOTTLED WATER/SNACK",
  "COURTESY RIDE",
  "DIAGNOSIS",
  "FIRE EXTINGUISHER",
  "FUEL DELIVERY",
  "JUMP START",
  "MAJOR REPAIR",
  "MINOR REPAIR",
  "PUSH/PULL/TOW/RECOVERY",
  "DEBRIS REMOVAL",
  "SAFETY CHECK",
  "SAFETY ESCORT",
  "TIRE CHANGE",
  "TRAFFIC CONTROL",
  "TRANSLATE",
];
